import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-1 text-terra-star ${className}`} role="img" aria-label="5 de 5 estrellas" data-id="element-156" data-mp="3ksqed3yqba5f">
      {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-5 w-5 fill-current" strokeWidth={0} aria-hidden="true" data-id="element-157" data-mp="3b1cir79weuhk" />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-paper py-20 sm:py-28" aria-labelledby="testimonials-title" data-id="element-158" data-mp="31zw951qwqwee">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-159" data-mp="321z6k6ue3rt5">
        <div className="text-center" data-id="element-160" data-mp="2x1kzar0m4lw6">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-terra" data-id="element-161" data-mp="2x2mnlx6n34vu">Lo que dicen los profesionales</p>
          <Stars className="mt-5 justify-center" data-id="element-162" data-mp="v96k3zpgdvjg" />
          <h2 id="testimonials-title" className="mt-4 font-display text-[2.2rem] leading-tight text-petrol sm:text-5xl" data-id="element-163" data-mp="v8wtc9wl3kcp">
            Testimonios de profesionales
          </h2>
        </div>

        <ul className="mt-14 space-y-6" data-id="element-164" data-mp="h55ai23t7vx3">
          {testimonials.map(t => <li key={t.name} className="rounded-[2rem] bg-cream/70 px-7 py-9 sm:px-12 sm:py-12" data-id="element-165" data-mp="m5b2xkhwlmg8">
              <Stars data-id="element-166" data-mp="78k4bdg20ero" />
              <blockquote className="mt-6 font-display text-[1.4rem] italic leading-[1.4] text-petrol sm:text-[1.7rem]" data-id="element-167" data-mp="7924um9r1f5e">
                “{t.quote}”
              </blockquote>
              <p className="mt-8 font-semibold text-petrol" data-id="element-168" data-mp="zw66ch9mvbcf">{t.name}</p>
              <p className="mt-1 text-sm text-ink-mute" data-id="element-169" data-mp="14vj07lyx9ioi">{t.role}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}